<template>
  <div>

    <div class="has-text-centered mb-6">
      <h1 class="title is-3">Impostazioni</h1>
    </div>

    <div class="tabs is-centered is-boxed">
      <ul>
        <li :class="{'is-active': tabActive === 'settings'}" @click="tabActive = 'settings'" v-if="$store.getters.amAdmin">
          <a>
            <span class="icon is-small"><font-awesome-icon icon="cog" /></span>
            <span>Generali</span>
          </a>
        </li>
        <li :class="{'is-active': tabActive === 'implants'}" @click="tabActive = 'implants'" v-if="$store.getters.amAdmin">
          <a>
            <span class="icon is-small"><font-awesome-icon icon="temperature-arrow-up" /></span>
            <span>Impianti</span>
          </a>
        </li>
        <li :class="{'is-active': tabActive === 'users'}" @click="tabActive = 'users'" v-if="$store.getters.amAdmin">
          <a>
            <span class="icon is-small"><font-awesome-icon icon="user-cog" /></span>
            <span>Utenti</span>
          </a>
        </li>
        <li :class="{'is-active': tabActive === 'info'}" @click="tabActive = 'info'">
          <a>
            <span class="icon is-small"><font-awesome-icon icon="user" /></span>
            <span>Profilo</span>
          </a>
        </li>
      </ul>
    </div>

    <transition name="fade" mode="out-in" v-if="$store.getters.amAdmin">
      <div v-show="tabActive === 'settings'">
        <div class="columns is-multiline is-centered">
          <div class="column is-half-desktop">
            <div class="field">
              <label class="label has-text-centered is-size-4">Tipologia appuntamenti</label>
              <div class="has-text-right">
                <button class="button is-success" @click="operation_types.push({})"><font-awesome-icon icon="plus" />Aggiungi</button>
              </div>
              <div class="control">
                <div class="b-table has-pagination" :class="{'is-loading': loading}">
                  <div class="table-wrapper has-mobile-cards">
                    <table class="table is-fullwidth is-striped is-hoverable">
                      <thead>
                      <tr>
                        <th>Nome</th>
                        <th style="width: 50px;">Manutenzione</th>
                        <th style="width: 80px;">Documentazione mancante</th>
                        <th style="width: 80px;">Note obbligatorie</th>
                        <th style="width: 80px;">Progressivo</th>
                        <th style="min-width: 100px;"></th>
                      </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(type, index) in operation_types" :key="index">
                          <td data-label="Nome">
                            <input class="input" type="text" placeholder="Nome" v-model="type.name" />
                          </td>
                          <td data-label="Manutenzione">
                            <label class="checkbox">
                              <input type="checkbox" v-model="type.maintenance">
                            </label>
                          </td>
                          <td data-label="Documentazione mancante">
                            <label class="checkbox">
                              <input type="checkbox" v-model="type.documentation">
                            </label>
                          </td>
                          <td data-label="Note obbligatorie">
                            <label class="checkbox">
                              <input type="checkbox" v-model="type.notes">
                            </label>
                          </td>
                          <td data-label="Progressivo">
                            <label class="checkbox">
                              <input type="checkbox" v-model="type.progressive">
                            </label>
                          </td>
                          <td class="is-actions-cell is-justify-content-flex-end">
                            <div class="buttons is-right">
                              <button class="button is-danger" @click="operation_types = operation_types.filter((type, typeIndex) => typeIndex !== index)" title="Elimina">
                                <span class="icon"><font-awesome-icon icon="trash-can" /></span>
                              </button>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <div class="mt-4">
              <button class="button is-primary is-fullwidth" @click="saveOperationTypes()"><font-awesome-icon icon="save" />Salva</button>
            </div>
          </div>

          <div class="column is-12"><hr /></div>

          <div class="column is-half-desktop">
            <div class="field">
              <label class="label has-text-centered is-size-4">Tipologia revisioni</label>
              <div class="has-text-right">
                <button class="button is-success" @click="revision_types.push({})"><font-awesome-icon icon="plus" />Aggiungi</button>
              </div>
              <div class="control">
                <div class="b-table has-pagination" :class="{'is-loading': loading}">
                  <div class="table-wrapper has-mobile-cards">
                    <table class="table is-fullwidth is-striped is-hoverable">
                      <thead>
                      <tr>
                        <th>Nome</th>
                        <th style="width: 50px;">Bollino</th>
                        <th style="width: 120px;">Periodo (anni)</th>
                        <th style="width: 120px;">Periodo (mesi)</th>
                        <th style="min-width: 100px;"></th>
                      </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(type, index) in revision_types" :key="index">
                          <td data-label="Nome">
                            <input class="input" type="text" placeholder="Nome" v-model="type.name" />
                          </td>
                          <td data-label="Bollino">
                            <label class="checkbox">
                              <input type="checkbox" v-model="type.stamp">
                            </label>
                          </td>
                          <td data-label="Periodo (anni)">
                            <input class="input" type="number" placeholder="Periodo (anni)" v-model="type.years" />
                          </td>
                          <td data-label="Periodo (mesi)">
                            <input class="input" type="number" placeholder="Periodo (mesi)" v-model="type.months" />
                          </td>
                          <td class="is-actions-cell is-justify-content-flex-end">
                            <div class="buttons is-right">
                              <button class="button is-danger" @click="revision_types = revision_types.filter((type, typeIndex) => typeIndex !== index)" title="Elimina">
                                <span class="icon"><font-awesome-icon icon="trash-can" /></span>
                              </button>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <div class="mt-4">
              <button class="button is-primary is-fullwidth" @click="saveRevisionTypes()"><font-awesome-icon icon="save" />Salva</button>
            </div>
          </div>

          <div class="column is-12"><hr /></div>

          <div class="column is-half-desktop">
            <div class="field">
              <label class="label has-text-centered is-size-4">Città abilitate abbonamenti</label>
              <div class="has-text-right">
                <button class="button is-success" @click="subscription_enabled_cities.push({})"><font-awesome-icon icon="plus" />Aggiungi</button>
              </div>
              <div class="control">
                <div class="b-table has-pagination" :class="{'is-loading': loading}">
                  <div class="table-wrapper has-mobile-cards">
                    <table class="table is-fullwidth is-striped is-hoverable">
                      <thead>
                      <tr>
                        <th>Città</th>
                        <th style="min-width: 100px;"></th>
                      </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(city, index) in subscription_enabled_cities" :key="index">
                          <td data-label="Città">
                            <input class="input" type="text" placeholder="Città" v-model="city.name" />
                          </td>
                          <td class="is-actions-cell is-justify-content-flex-end">
                            <div class="buttons is-right">
                              <button class="button is-danger" @click="subscription_enabled_cities = subscription_enabled_cities.filter((row, rowIndex) => rowIndex !== index)" title="Elimina">
                                <span class="icon"><font-awesome-icon icon="trash-can" /></span>
                              </button>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <div class="mt-4">
              <button class="button is-primary is-fullwidth" @click="saveSubscriptionEnabledCities()"><font-awesome-icon icon="save" />Salva</button>
            </div>
          </div>

        </div>
      </div>
    </transition>

    <transition name="fade" mode="out-in" v-if="$store.getters.amAdmin">
      <div v-show="tabActive === 'implants'">
        <div class="columns is-multiline is-centered">

          <div class="column is-half-desktop">
            <div class="field">
              <label class="label has-text-centered is-size-4">Marca impianto</label>
              <div class="buttons mb-0 is-justify-content-flex-end">
                <button class="button mb-0 is-primary" @click="regenBrands()" disabled><font-awesome-icon icon="cog" />Rigenera</button>
                <button class="button mb-0 is-success" @click="implant_brands.push({new: true})"><font-awesome-icon icon="plus" />Aggiungi</button>
              </div>
              <div class="control">
                <div class="b-table has-pagination" :class="{'is-loading': loading}">
                  <div class="table-wrapper has-mobile-cards">
                    <table class="table is-fullwidth is-striped is-hoverable">
                      <thead>
                      <tr>
                        <th>Nome</th>
                        <th style="min-width: 100px;"></th>
                      </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(brand, index) in implant_brands" :key="index">
                          <td data-label="Nome">
                            <input class="input" type="text" placeholder="Nome" v-model="brand.name" />
                          </td>
                          <td class="is-actions-cell is-justify-content-flex-end">
                            <div class="buttons is-right">
                              <button class="button is-danger" @click="implant_brands = implant_brands.filter((brand, brandIndex) => brandIndex !== index)" title="Elimina">
                                <span class="icon"><font-awesome-icon icon="trash-can" /></span>
                              </button>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <div class="mt-4">
              <button class="button is-primary is-fullwidth" @click="saveImplantBrands()"><font-awesome-icon icon="save" />Salva</button>
            </div>
          </div>

          <div class="column is-12"><hr /></div>

          <div class="column is-half-desktop">
            <div class="field">
              <label class="label has-text-centered is-size-4">Modello impianto</label>
              <div class="buttons mb-0 is-justify-content-flex-end">
                <button class="button mb-0 is-primary" @click="regenModels()" disabled><font-awesome-icon icon="cog" />Rigenera</button>
                <button class="button mb-0 is-success" @click="implant_models.push({new: true})"><font-awesome-icon icon="plus" />Aggiungi</button>
              </div>
              <div class="control">
                <div class="b-table has-pagination" :class="{'is-loading': loading}">
                  <div class="table-wrapper has-mobile-cards">
                    <table class="table is-fullwidth is-striped is-hoverable">
                      <thead>
                      <tr>
                        <th>Nome</th>
                        <th style="min-width: 100px;"></th>
                      </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(model, index) in implant_models" :key="index">
                          <td data-label="Nome">
                            <input class="input" type="text" placeholder="Nome" v-model="model.name" />
                          </td>
                          <td class="is-actions-cell is-justify-content-flex-end">
                            <div class="buttons is-right">
                              <button class="button is-primary" type="button" @click="showModelFileModal(model.name)" title="Allegati">
                                <span v-if="$store.getters.modelFiles(model.name).length" class="mr-2">{{ $store.getters.modelFiles(model.name).length }}</span>
                                <font-awesome-icon icon="paperclip" class="m-0" />
                              </button>
                              <button class="button is-danger" @click="implant_models = implant_models.filter((model, modelIndex) => modelIndex !== index)" title="Elimina">
                                <span class="icon"><font-awesome-icon icon="trash-can" /></span>
                              </button>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <div class="mt-4">
              <button class="button is-primary is-fullwidth" @click="saveImplantModels()"><font-awesome-icon icon="save" />Salva</button>
            </div>
          </div>

        </div>

        <Modal :title="'Gestione allegati modello'" :openModal="openModalFiles" @close="openModalFiles = false" :noAction="true">
          <FileList v-if="openModalFiles" :id="openedModel" type="setting/model" />
        </Modal>
      </div>
    </transition>

    <transition name="fade" mode="out-in" v-if="$store.getters.amAdmin">
      <div v-show="tabActive === 'users'">
        <div class="columns is-multiline is-centered">
          <div class="column is-two-thirds-desktop">
            <div class="field">
              <label class="label has-text-centered is-size-4">Gestione utenti</label>
              <div class="has-text-right">
                <button class="button is-success" @click="allUsers.push({})"><font-awesome-icon icon="plus" />Aggiungi</button>
              </div>
              <div class="control">
                <div class="b-table has-pagination">
                  <div class="table-wrapper has-mobile-cards">
                    <table class="table is-fullwidth is-striped is-hoverable">
                      <thead>
                      <tr>
                        <th>Nome</th>
                        <th>Cognome</th>
                        <th>Username</th>
                        <th>Admin</th>
                        <th>Collaboratore</th>
                        <th>Firma</th>
                        <th>Colore</th>
                        <th>Festivus</th>
                        <th style="min-width: 100px;"></th>
                      </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(user, index) in allUsers" :key="index" :class="{'tempRow': !user._id}">
                          <td data-label="Nome">
                            <input class="input" type="text" placeholder="Nome" v-model="user.name" />
                          </td>
                          <td data-label="Cognome">
                            <input class="input" type="text" placeholder="Cognome" v-model="user.surname" />
                          </td>
                          <td data-label="Username">
                            <input class="input" type="text" placeholder="Username" v-model="user.email" />
                          </td>
                          <td data-label="Admin">
                            <label class="checkbox">
                              <input type="checkbox" v-model="user.isAdmin">
                            </label>
                          </td>
                          <td data-label="Collaboratore">
                            <label class="checkbox">
                              <input type="checkbox" v-model="user.isOperator">
                            </label>
                          </td>
                          <td data-label="Firma">
                            <div class="is-flex is-align-items-center" style="gap: 0.5rem; flex-wrap: wrap;">
                              <span class="tag" :class="user.signature_url ? 'is-success' : 'is-light'">
                                {{ user.signature_url ? 'Caricata' : 'Assente' }}
                              </span>
                              <label
                                :class="'button is-small is-link' + (user.signature_url ? ' is-disabled' : '')"
                                :style="user.signature_url ? 'pointer-events: none; opacity: 0.5; cursor: not-allowed;' : ''"
                              >
                                <font-awesome-icon icon="upload" class="m-0" />
                                <input type="file" accept="image/*" style="display:none" :disabled="!!user.signature_url" @change="uploadUserSignature(user, $event)">
                              </label>
                              <button class="button is-small is-danger" type="button" title="Rimuovi firma" :disabled="!user._id || !user.signature_url" @click="deleteUserSignature(user)">
                                <span class="icon"><font-awesome-icon icon="trash-can" /></span>
                              </button>
                            </div>
                          </td>
                          <td data-label="Colore">
                            <label class="checkbox">
                              <div class="select">
                                <select v-model="user.color" :class="user.color ? user.color + '-bg' : null">
                                  <option value="custom-blue" class="custom-blue-bg">Blu</option>
                                  <option value="custom-green" class="custom-green-bg">Verde</option>
                                  <option value="custom-orange" class="custom-orange-bg">Arancione</option>
                                  <option value="custom-red" class="custom-red-bg">Rosso</option>
                                  <option value="custom-purple" class="custom-purple-bg">Viola</option>
                                  <option value="custom-brown" class="custom-brown-bg">Marrone</option>
                                  <option value="custom-lime" class="custom-lime-bg">Lime</option>
                                </select>
                              </div>
                            </label>
                          </td>
                          <td data-label="Festivus">
                            <label class="checkbox">
                              <input type="checkbox" v-model="user.festivus">
                            </label>
                          </td>
                          <td class="is-actions-cell is-justify-content-flex-end">
                            <div class="buttons is-right">
                              <button v-if="user._id" class="button is-success" @click="updateUser(user)" title="Salva" :class="[{'is-loading': user.waitSave}]" :disabled="user.waitSave || user.waitDelete">
                                <span class="icon"><font-awesome-icon icon="save" /></span>
                              </button>
                              <button v-if="!user._id" class="button is-success" @click="saveUser(user, index)" title="Salva" :class="[{'is-loading': user.waitSave}]" :disabled="user.waitSave || user.waitDelete">
                                <span class="icon"><font-awesome-icon icon="save" /></span>
                              </button>
                              <button class="button is-primary" @click="changeUserPassword(user)" title="Modifica password" :disabled="!user._id || user.waitSave || user.waitDelete">
                                <span class="icon"><font-awesome-icon icon="key" /></span>
                              </button>
                              <button v-if="user._id" class="button is-danger" @click="deleteUser(user)" title="Elimina" :class="[{'is-loading': user.waitDelete}]" :disabled="!user._id || user.waitSave || user.waitDelete">
                                <span class="icon"><font-awesome-icon icon="trash-can" /></span>
                              </button>
                              <button v-if="!user._id" class="button is-danger" @click="allUsers = allUsers.filter((u, uIndex) => uIndex !== index)" title="Elimina">
                                <span class="icon"><font-awesome-icon icon="trash-can" /></span>
                              </button>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </transition>
    
    <transition name="fade" mode="out-in">
      <div v-show="tabActive === 'info'">
        <div class="columns is-multiline is-centered">

          <div class="column is-half-desktop">
            <label class="label has-text-centered is-size-4">Modifica profilo</label>

            <div class="field">
              <label class="label">Nome</label>
              <div class="control">
                <input class="input" type="text" placeholder="Nome" v-model="user.name">
              </div>
            </div>
            <div class="field">
              <label class="label">Cognome</label>
              <div class="control">
                <input class="input" type="text" placeholder="Cognome" v-model="user.surname">
              </div>
            </div>
            <div class="field">
              <label class="label">Email</label>
              <div class="control">
                <input class="input" type="text" placeholder="Email" disabled  v-model="user.email">
              </div>
            </div>

            <div class="mt-4">
              <button class="button is-primary is-fullwidth" @click="saveProfile()"><font-awesome-icon icon="save" />Salva</button>
            </div>

          </div>

          <div class="column is-12"><hr /></div>

          <div class="column is-half-desktop">
            <form id="formPassword" @submit.prevent="changePassword()">
            
              <label class="label has-text-centered is-size-4">Cambia password</label>

              <div class="field">
                <label class="label">Nuova password</label>
                <div class="control">
                  <input class="input" type="password" placeholder="Nuova password" minlength="8" v-model="newPassword.value" required pattern="(?=.*\d)(?=.*[\W_]).{8,}" title="Minimo 8 caratteri. Ci deve essere almeno un carattere speciale e un numero.">
                </div>
              </div>
              <div class="field">
                <label class="label">Ripeti nuova password</label>
                <div class="control">
                  <input class="input" type="password" placeholder="Ripeti nuova password" minlength="8" v-model="newPassword.check" required>
                </div>
              </div>

              <div class="mt-4">
                <button type="submit" class="button is-primary is-fullwidth"><font-awesome-icon icon="save" />Salva</button>
              </div>
            </form>

          </div>

        </div>
      </div>
    </transition>

    <div class="modal" :class="{'is-active': openModalUserPassword}">
      <div class="modal-background" @click="openModalUserPassword = false"></div>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">Modifica password</p>
          <button class="delete" aria-label="close" @click="openModalUserPassword = false"></button>
        </header>
        <section class="modal-card-body">
          <form id="formUserPassword" @submit.prevent="saveUserPassword()">
            <div class="field">
              <label class="label">Nuova password</label>
              <div class="control">
                <input class="input" type="password" placeholder="Nuova password" minlength="8" v-model="userNewPassword.value" required pattern="(?=.*\d)(?=.*[\W_]).{8,}" title="Minimo 8 caratteri. Ci deve essere almeno un carattere speciale e un numero.">
              </div>
            </div>
            <div class="field">
              <label class="label">Ripeti nuova password</label>
              <div class="control">
                <input class="input" type="password" placeholder="Ripeti nuova password" minlength="8" v-model="userNewPassword.check" required>
              </div>
            </div>
          </form>
        </section>
        <footer class="modal-card-foot is-flex is-justify-content-end">
          <button class="button" @click="openModalUserPassword = false"><font-awesome-icon icon="times" />Chiudi</button>
          <button type="submit" form="formUserPassword" class="button is-primary"><font-awesome-icon icon="save" />Salva</button>
        </footer>
      </div>
    </div>
  </div>
</template>

<script>
import cloneDeep from 'lodash.clonedeep'

export default {
  data() {
    return {
      user: {},
      allUsers: [],

      implant_brands: [],
      implant_models: [],
      operation_types: [],
      revision_types: [],
      subscription_enabled_cities: [],

      newPassword: {
        value: '',
        check: ''
      },

      loading: false,

      savingAllUsers: false,

      tabActive: this.$store.getters.amAdmin ? 'settings' : 'info',

      openModalUserPassword: false,
      userNewPassword: {},

      openedModel: null,
      openModalFiles: false
    }
  },

  methods: {
    init() {
      this.implant_brands = cloneDeep(this.$store.state.implant_brands)
      this.implant_models = cloneDeep(this.$store.state.implant_models)
      this.operation_types = cloneDeep(this.$store.state.operation_types)
      this.revision_types = cloneDeep(this.$store.state.revision_types)
      this.subscription_enabled_cities = cloneDeep(this.$store.state.subscription_enabled_cities)
    },

    saveProfile() {
      this.$http.post('/user/profile', {
        name: this.user.name,
        surname: this.user.surname
      })
      .then(function (response) {
        location.reload()
      })
      .catch(function (error) {
        console.log(error)
        alert('Errore')
      })
    },

    changePassword() {
      if (this.newPassword.value !== this.newPassword.check) {
        alert('Le due password non corrispondono!')
        return false
      }

      this.$http.post('/user/change-password', {
        password: this.newPassword.value
      })
      .then(function (response) {
        location.reload()
      })
      .catch(function (error) {
        console.log(error)
        alert('Errore')
      })
    },

    saveUser(user, userIndex) {
      const self = this
      user.waitSave = true

      this.$http.post('/user', user)
      .then(function (response) {
        user.waitSave = false
        self.allUsers = self.allUsers.filter((u, uIndex) => uIndex !== userIndex)
        self.allUsers.push(response.data)
        self.$store.commit('setAllUsers', self.allUsers)
        self.allUsers = cloneDeep(self.$store.getters.users)
      })
      .catch(function (error) {
        console.log(error)
        alert('Errore')
        user.waitSave = false
      })
    },

    updateUser(user) {
      const self = this
      user.waitSave = true

      this.$http.put('/user/' + user._id, user)
      .then(function (response) {
        user.waitSave = false
        user = response.data.user
        self.$store.commit('setAllUsers', self.allUsers)
        self.allUsers = cloneDeep(self.$store.getters.users)
      })
      .catch(function (error) {
        console.log(error)
        alert('Errore')
        user.waitSave = false
      })
    },

    uploadUserSignature(user, event) {
      const self = this
      const file = event?.target?.files?.[0]

      if (user?.signature_url) {
        if (event?.target) {
          event.target.value = ''
        }
        return
      }

      if (!file || !user?._id) {
        return
      }

      if (!file.type?.startsWith('image/')) {
        alert('Seleziona un file immagine')
        event.target.value = ''
        return
      }

      const formData = new FormData()
      formData.append('file', file)

      this.$http.post('/user/' + user._id + '/signature', formData)
      .then(function (response) {
        const updatedUser = response.data
        const userIndex = self.allUsers.findIndex(u => u._id === updatedUser._id)
        if (userIndex !== -1) {
          self.allUsers[userIndex] = Object.assign({}, self.allUsers[userIndex], updatedUser)
        }

        self.$store.commit('setAllUsers', self.allUsers)
        self.allUsers = cloneDeep(self.$store.getters.users)

        event.target.value = ''
      })
      .catch(function (error) {
        console.log(error)
        alert('Errore upload firma')
      })
    },

    deleteUserSignature(user) {
      const self = this

      if (!user?._id || !user.signature_url) {
        return
      }
      if (!confirm('Rimuovere la firma di questo utente?')) {
        return
      }

      this.$http.delete('/user/' + user._id + '/signature')
      .then(function () {
        const userIndex = self.allUsers.findIndex(u => u._id === user._id)
        if (userIndex !== -1) {
          self.allUsers[userIndex].signature_url = ''
          self.allUsers[userIndex].signature_name = ''
          self.allUsers[userIndex].signature_updated_at = null
        }

        self.$store.commit('setAllUsers', self.allUsers)
        self.allUsers = cloneDeep(self.$store.getters.users)
      })
      .catch(function (error) {
        console.log(error)
        alert('Errore rimozione firma')
      })
    },
    
    deleteUser(user) {
      if(confirm('Eliminare?')) {
        const self = this
        user.waitDelete = true

        this.$http.delete('/user/' + user._id)
        .then(function (response) {
          const newUsers = self.allUsers.filter(u => u._id !== user._id)

          self.$store.commit('setAllUsers', newUsers)
          self.allUsers = cloneDeep(self.$store.getters.users)
        })
        .catch(function (error) {
          console.log(error)
          alert('Errore')
          user.waitDelete = false
        })
      }
    },

    changeUserPassword(user) {
      this.openModalUserPassword = true
      this.userNewPassword.user = user
    },

    saveUserPassword() {
      const self = this

      if (this.userNewPassword.value !== this.userNewPassword.check) {
        alert('Le due password non corrispondono!')
        return false
      }

      this.$http.post('/user/' + this.userNewPassword.user._id + '/change-password', {
        password: this.userNewPassword.value
      })
      .then(function (response) {
        self.userNewPassword.value = ''
        self.userNewPassword.check = ''
        self.openModalUserPassword = false
      })
      .catch(function (error) {
        console.log(error)
        alert('Errore')
      })
    },

    getSettings() {
      const self = this

      self.loading = true

      this.$http.get('/setting')
      .then(function (response) {
        if (response.data) {
          self.$store.commit('setSettings', response.data)

          self.init()
        }

        self.loading = false
      })
      .catch(function (error) {
        console.log(error)
        alert('Errore')
        self.loading = false
      })
    },
    
    saveImplantBrands() {
      const self = this

      //rimuovo eventuali nuovi inserimenti duplicati
      self.implant_brands = self.implant_brands.filter(brand => !brand.new || (self.implant_brands.filter(b => b.name.toUpperCase() === brand.name.toUpperCase()).length <= 1))

      self.implant_brands.forEach((element, index) => {
        delete self.implant_brands[index].new
      })

      this.$http.put('/setting/implant_brands', {
        value: self.implant_brands
      })
      .then(function (response) {
        self.getSettings()
      })
      .catch(function (error) {
        console.log(error)
        alert('Errore')
      })
    },

    saveImplantModels() {
      const self = this

      //rimuovo eventuali nuovi inserimenti duplicati
      self.implant_models = self.implant_models.filter(model => !model.new || (self.implant_models.filter(m => m.name.toUpperCase() === model.name.toUpperCase()).length <= 1))

      self.implant_models.forEach((element, index) => {
        delete self.implant_models[index].new
      })

      this.$http.put('/setting/implant_models', {
        value: self.implant_models
      })
      .then(function (response) {
        self.getSettings()
      })
      .catch(function (error) {
        console.log(error)
        alert('Errore')
      })
    },

    saveOperationTypes() {
      const self = this

      this.$http.put('/setting/operation_types', {
        value: self.operation_types
      })
      .then(function (response) {
        self.getSettings()
      })
      .catch(function (error) {
        console.log(error)
        alert('Errore')
      })
    },

    saveRevisionTypes() {
      const self = this

      const invalidType = self.revision_types.find(type => {
        const years = Number(type?.years || 0)
        const months = Number(type?.months || 0)
        return years > 0 && months > 0
      })

      if (invalidType) {
        alert(`La tipologia "${invalidType.name || '-'}" ha sia anni che mesi: valorizza solo uno dei due campi.`)
        return false
      }

      this.$http.put('/setting/revision_types', {
        value: self.revision_types
      })
      .then(function (response) {
        self.getSettings()
      })
      .catch(function (error) {
        console.log(error)
        alert('Errore')
      })
    },

    saveSubscriptionEnabledCities() {
      const self = this

      this.$http.put('/setting/subscription_enabled_cities', {
        value: self.subscription_enabled_cities
      })
      .then(function () {
        self.getSettings()
      })
      .catch(function (error) {
        console.log(error)
        alert('Errore')
      })
    },

    regenBrands() {
      const self = this

      this.$http.get('/setting/regen-brands')
      .then(function (response) {
        self.getSettings()
      })
      .catch(function (error) {
        console.log(error)
        alert('Errore')
      })
    },

    regenModels() {
      const self = this

      this.$http.get('/setting/regen-models')
      .then(function (response) {
        self.getSettings()
      })
      .catch(function (error) {
        console.log(error)
        alert('Errore')
      })
    },

    showModelFileModal(name) {
      this.openedModel = name
      this.openModalFiles = true
    }
  },

  mounted() {
    this.user = Object.assign({}, this.$store.state.user)

    this.allUsers = cloneDeep(this.$store.getters.users)

    this.init()
  }
}
</script>

<style scoped>
.tempRow {
  background-color: #ffff0022 !important;
}
</style>